import { Button, ListView, ellipsesHorizontalIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { type MouseEvent, type ReactElement, type SVGProps } from "react";

import { Popover } from "./Popover";
import { ListViewItemWithActions } from "./listViewWithActions/ListViewItemWithActions";

export interface MenuItem {
  icon: (prefix?: string) => SVGProps<SVGElement>[];
  title: string;
  disabled?: boolean;
  onClick: (e?: MouseEvent) => void;
}

interface MenuButtonProps {
  menuItems: MenuItem[];
  trigger?: ReactElement;
  shouldOpen?: boolean;
}

export const MenuButton = ({
  menuItems,
  trigger,
  shouldOpen = true,
}: MenuButtonProps) => (
  <Popover
    closeOnClick
    trigger={
      trigger ?? (
        <Button
          text={t("label.more_actions")}
          title={t("label.more_actions")}
          iconOnly
          ssrIcon={ellipsesHorizontalIcon}
          size="small"
          type="secondary"
        />
      )
    }
  >
    {shouldOpen && (
      <ListView id="task-menu-more">
        {menuItems.map((item) => (
          <ListViewItemWithActions
            key={`task-menu-more-${item.title}`}
            inset
            title={item.title}
            icon={item.icon}
            onClick={item.onClick}
            disabled={item.disabled ?? false}
            extraPadding
          />
        ))}
      </ListView>
    )}
  </Popover>
);
